export enum Citizenship {
  US_CITIZEN = 'US_CITIZEN',
  PERMANENT_RESIDENT = 'PERMANENT_RESIDENT',
  VISA_HOLDER = 'VISA_HOLDER',
  NON_VISA_HOLDER = 'NON_VISA_HOLDER',
}

export const customCitizenshipDisplay = new Map<string, string>([
  [Citizenship.US_CITIZEN, 'US Citizen'],
  [Citizenship.PERMANENT_RESIDENT, 'Permanent Resident'],
  [Citizenship.VISA_HOLDER, 'Visa Holder'],
  [Citizenship.NON_VISA_HOLDER, 'Non Visa Holder'],
]);
